function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, React.createElement("rect", {
  width: 60,
  height: 60,
  fill: "#fff"
}), React.createElement("path", {
  d: "M12.11,27H22.55a3,3,0,0,1,3,3v0a3,3,0,0,1-3,3H12.11a2.89,2.89,0,0,1-2.89-2.89v-.22A2.89,2.89,0,0,1,12.11,27Z",
  fill: "#fff",
  stroke: "#adafb5",
  strokeMiterlimit: 10,
  strokeWidth: 0.83
}), React.createElement("circle", {
  cx: 22.54,
  cy: 30,
  r: 3,
  fill: "#fff",
  stroke: "#adafb5",
  strokeMiterlimit: 10,
  strokeWidth: 0.78
}), React.createElement("line", {
  x1: 23.17,
  y1: 30,
  x2: 36.8,
  y2: 30,
  fill: "none",
  stroke: "#adafb5",
  strokeLinecap: "round",
  strokeMiterlimit: 10,
  strokeWidth: 2
}), React.createElement("rect", {
  x: 34,
  y: 27,
  width: 15.78,
  height: 6,
  rx: 3,
  fill: "#fff",
  stroke: "#adafb5",
  strokeMiterlimit: 10,
  strokeWidth: 0.87
}), React.createElement("circle", {
  cx: 46.77,
  cy: 30,
  r: 3,
  fill: "#fff",
  stroke: "#adafb5",
  strokeMiterlimit: 10,
  strokeWidth: 0.81
}), React.createElement("polygon", {
  points: "29.9 28.96 33.4 20.61 26.4 20.61 29.9 28.96",
  fill: "#adafb5",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.44
}), React.createElement("polygon", {
  points: "29.9 31.04 33.4 39.4 26.4 39.4 29.9 31.04",
  fill: "#adafb5",
  stroke: "#fff",
  strokeMiterlimit: 10,
  strokeWidth: 0.44
})));

function SvgSplice(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 60 60"
  }, props), _ref);
}

export default __webpack_public_path__ + "static/media/splice.e3b0fa14.svg";
export { SvgSplice as ReactComponent };